import type { FC, ReactNode } from "react";
import { Toaster } from "@/components/ui/toaster";

interface ToastProviderProps {
	children: ReactNode;
}

export const ToastProvider: FC<ToastProviderProps> = ({ children }) => {
	return (
		<>
			{children}
			<Toaster />
		</>
	);
};
